module.exports = __webpack_public_path__ + "img/play.e10eb6c1.png";